export default __webpack_public_path__ + "static/sol-98a86ea4109e6b37d1a81a7f40df2108.png";